import { ErrorText } from '@main/core-ui';
import React from 'react';
import { useIntl } from 'react-intl';

import { requiredEnabledAirgapMessages } from './messages';

// TODO: https://transcend.height.app/T-37918 - try to remove this
export const RequiredEnabledAirgap: React.FC = () => {
  const { formatMessage } = useIntl();
  return (
    <div>
      <ErrorText>
        {formatMessage(requiredEnabledAirgapMessages.enableAirgap)}
      </ErrorText>
    </div>
  );
};
